
export const LayoutStyleType = {
    Stack: 'Stack',
    Relative: 'Relative'
} as const;
export type LayoutStyleType = typeof LayoutStyleType[keyof typeof LayoutStyleType];
